export default __webpack_public_path__ + "static/media/download-icon.a0a71ad8.svg";